import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {Observable} from 'rxjs/Observable';

import {FieldRequestParameters, RequestParameters} from '../../models/request-parameters/parameter.model';
import {FormControl} from '@angular/forms';
import {City} from '../../../parameters/cities/city.model';
import {CityService} from '../../../parameters/cities/city.service';
import {Country} from '../../../parameters/countries/country.model';

@Component({
  selector: 'app-cities-autocomplete',
  templateUrl: './cities-autocomplete.component.html',
  styleUrls: ['./cities-autocomplete.component.scss']
})
export class CitiesAutocompleteComponent implements OnInit, OnChanges {

  @Input('cityFormControl') cityFormControl: FormControl;
  @Input('placeholder') placeholder: string;
  @Input('country') country: Country;
  @Output() onCitySelected: EventEmitter<City> = new EventEmitter<City>();

  @ViewChild('autoCities') autoCities: ElementRef;

  cities: Observable<any> = new Observable<any>();
  cityLoading: boolean = true;
  cityParameters: RequestParameters = new RequestParameters();

  constructor(private cityService: CityService) {
  }

  ngOnInit() {
    if (this.country !== null && this.country !== undefined) {
      this.cityParameters.fields.push(new FieldRequestParameters('state.country', this.country.reference));
    }
    this.updateCities();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.cityParameters = new RequestParameters();
    if (changes.hasOwnProperty('country')) {
      if (this.country !== null && this.country !== undefined) {
        this.cityParameters.fields.push(new FieldRequestParameters('state.country', this.country.reference));
      }
    }
    this.updateCities();
  }

  onSelectCity() {
    this.onCitySelected.emit(this.cityFormControl.value);
  }

  displayCities (city: City) {
    if (city !== null) {
      return city.name;
    }
  }

  filterCities (filterInput: string = '') {
    if (this.cityParameters.searchString !== filterInput) {
      this.cityParameters.searchString = filterInput;
      this.updateCities();
    }
  }

  updateCities () {
    this.cityLoading = true;
    this.cities = this.cityService.getCities(this.cityParameters)
      .map(
        (response) => {
          this.cityLoading = false;
          return response.result;
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/cities-autocomplete/cities-autocomplete.component.ts